import { spacePasswordSchema } from "./space-password.js";
import { spaceAccessModeSchema, spaceAccessModeUsesPassword } from "./space-access-mode.js";
import { spaceOrganizationVisibilitySchema } from "./space-meta.js";
import * as z$1 from "zod/v4";
//#region src/schemas/http/space-create.ts
const createSpaceBodySchema = z$1.strictObject({
	name: z$1.unknown().optional(),
	purpose: z$1.unknown().optional(),
	guide: z$1.unknown().optional(),
	visibility: z$1.unknown().optional(),
	accessMode: z$1.unknown().optional(),
	password: z$1.unknown().optional()
}).transform((value, ctx) => {
	const next = {};
	if (typeof value.name === "string") {
		const normalizedName = value.name.trim();
		if (normalizedName.length > 0) next.name = normalizedName;
	}
	if (Object.hasOwn(value, "purpose")) {
		if (typeof value.purpose !== "string") {
			ctx.addIssue({
				code: "custom",
				message: "Invalid purpose",
				path: ["purpose"]
			});
			return z$1.NEVER;
		}
		next.purpose = value.purpose.trim();
	}
	if (Object.hasOwn(value, "guide")) {
		if (typeof value.guide !== "string") {
			ctx.addIssue({
				code: "custom",
				message: "Invalid guide",
				path: ["guide"]
			});
			return z$1.NEVER;
		}
		next.guide = value.guide.trim();
	}
	const parsedVisibility = spaceOrganizationVisibilitySchema.safeParse(value.visibility);
	if (!parsedVisibility.success) {
		ctx.addIssue({
			code: "custom",
			message: "Invalid visibility",
			path: ["visibility"]
		});
		return z$1.NEVER;
	}
	if (Object.hasOwn(value, "accessMode")) {
		const parsedAccessMode = spaceAccessModeSchema.safeParse(value.accessMode);
		if (!parsedAccessMode.success) {
			ctx.addIssue({
				code: "custom",
				message: "Invalid accessMode",
				path: ["accessMode"]
			});
			return z$1.NEVER;
		}
		next.accessMode = parsedAccessMode.data;
	}
	if (Object.hasOwn(value, "password")) {
		const parsedPassword = spacePasswordSchema.safeParse(value.password);
		if (!parsedPassword.success) {
			ctx.addIssue({
				code: "custom",
				message: "Invalid password",
				path: ["password"]
			});
			return z$1.NEVER;
		}
		next.password = parsedPassword.data;
	}
	if (next.accessMode !== void 0 && !spaceAccessModeUsesPassword(next.accessMode) && next.password !== void 0) {
		ctx.addIssue({
			code: "custom",
			message: "Password cannot be set for this access",
			path: ["password"]
		});
		return z$1.NEVER;
	}
	if (next.accessMode !== void 0 && spaceAccessModeUsesPassword(next.accessMode) && next.password === void 0) {
		ctx.addIssue({
			code: "custom",
			message: "Password required for this access",
			path: ["password"]
		});
		return z$1.NEVER;
	}
	return {
		...next,
		visibility: parsedVisibility.data
	};
});
//#endregion
export { createSpaceBodySchema };

//# sourceMappingURL=space-create.js.map